import { Injectable } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router } from '@angular/router';

@Injectable()
export class SnackBarService {
    constructor(private notification: NzNotificationService, private router: Router, private message: NzMessageService) {}

    success(title): void {
        this.message.success(title);
    }

    warning(title): void {
        this.message.warning(title);
    }

    error(title): void {
        this.message.error(title);
    }

    snackBarSetting(title, type, css, duration = 5000): void {}

    openReminder(data, duration = 15000): void {
        const notinstance = this.notification.blank(data.title, data.content, { nzDuration: duration });
        notinstance.onClick.subscribe((res) => {
            const key = 'nodeName'
            if (res.target[key] === 'DIV') {
                if (data.url) {
                    // 有地址时页面跳转
                    this.router.navigate([data.url]);
                    if (data.fn) {
                        data.fn();
                        this.notification.remove(); // 销毁所有提示
                    }
                }
            }
        });
    }
}
